import { render, staticRenderFns } from "./StatsLost.vue?vue&type=template&id=49961aa6&scoped=true"
import script from "./StatsLost.vue?vue&type=script&lang=js"
export * from "./StatsLost.vue?vue&type=script&lang=js"
import style0 from "./StatsLost.vue?vue&type=style&index=0&id=49961aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49961aa6",
  null
  
)

export default component.exports